import { Component } from '@angular/core';

@Component({
  selector: 'app-links',
  template: `
  <div id="USDALinks">
  	<h2>USDA Links</h2>
  	<ul>
  		<li><a href="http://www.usda.gov" target="_blank">USDA Home</a></li>
  		<li><a href="http://www.ars.usda.gov" target="_blank">ARS Home</a></li>
  		<li><a href="http://www.ars.usda.gov/Aboutus/docs.htm?docid=13238" target="_blank">ARS CERCLA / Superfund</a></li>
  	</ul>
  </div>
  <div id="EPALinks">
    <h2>EPA Links</h2>
    <ul>
      <li><a href="http://www.epa.gov" target="_blank">EPA Home</a></li>
      <li><a href="http://www.epa.gov/oswer/cleanup" target="_blank">Cleanup Home</a></li>
      <li><a href="http://www.epa.gov/superfund" target="_blank">Superfund Home</a></li>
    </ul>
  </div>
  <div id="BARCLinks">
    <h2>BARC Fact Sheets / Maps</h2>
    <ul>
      <li>
        <a href="http://www.ars.usda.gov/sp2UserFiles/Place/12000000/CERCLA/AOC_Jun05.pdf" target="_blank">
          BARC's Areas of Concern (AOC) (pdf)
        </a>
      </li>
      <li>
        <a href="http://www.ars.usda.gov/sp2UserFiles/Place/12000000/CERCLA/InfoRepository.pdf" target="_blank">
          Information Repository (pdf)
        </a>
      </li>
      <li>
        <a href="http://www.ars.usda.gov/sp2UserFiles/Place/12000000/CERCLA/RevRemovalAct.pdf" target="_blank">
          Revised Removal Action (pdf)
        </a>
      </li>
      <li>
        <a href="http://www.ars.usda.gov/sp2UserFiles/Place/12000000/CERCLA/AOCmap_2005.pdf" target="_blank">
          Status of Investigations as of June 1, 2005 (Map) (pdf)
        </a>
      </li>
    </ul>
  </div>
  `
})
export class LinksComponent { }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/links.ts